import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login.js';

import Home from './components/Home.js';
import DeviceDetail from './components/DeviceDetail.js';

import Release from './components/Release.js';
import Template from './components/template';


import LockDevice from './components/LockDevice.js';
import UnlockDevice from './components/UnlockDevice.js';

import FormattedDevice from './components/FormattedDevice.js';


import Logout from './components/Logout.js';
import BlockApp from './components/Blockapp.js';
import UnblockApp from './components/Unblockapp.js';
import EnableNotification from './components/EnableNotification.js';
import Report from './components/Report.js';

import UserManagement from './components/UserManagement.js';
import ResetPassword from './components/ResetPassword.js';
import ForgotPassword from './components/ForgotPassword.js';
import KeyManagement from './components/KeyManagement.js';
// import DisableApp from './components/DisableApp.js';
import RestoreApp from './components/RestoreApp.js';
import SetWallpaper from './components/SetWallpaper.js';
import UnsetWallpaper from './components/RemoveWallpaper.js';
import ActivateAlarm from './components/ActivateAlarm.js';
import UnsetAlarm from './components/DeactivateAlarm.js';
import { decryptResponse } from './components/CryptoUtil.js';
import AuditReportByImei from './components/AuditReportByImei.js';
import EnableCamera from './components/EnableCamera.js';
import DisableCamera from './components/DisableCamera.js';
import NotAuthorised from './components/NotAuthorised.js';
import GradeDisableApp from './components/GradeDisableApp.js';

 import Batchprocess from './components/batchprocess.js';
import EnableCredit from './components/EnableCredit.js';
import RevokeCredit from './components/RevokeCredit.js';

import AppVersion from './components/AppVersion.js';
 import LastCommand from './components/LastCommand.js';
 import DeviceAction from './components/DeviceAction.js';
//  import ReProcess from './components/ReProcess.js';






export const BATCH_SIZE =50

const production = true;
export const withCredentials = true;
export const BASE_URL = production?"https://www.screenbroscho.com/":"https://www.screenbrosfinance.com/"
export const APP_URL = BASE_URL+"sbchwebapi/"

const PrivateRoute = ({ element: Component }) => {
  let isAuthenticated=false;
  let isPermission = false;
  let isAdmin = false;
  if(localStorage.getItem('userSession')){
    const permissions = JSON.parse(decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).permissions);
   
    const searchPermission = Component.displayName;
   

    isAdmin= decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).userlevel === 'ADMIN';
    if(isAdmin){
      isPermission =true;

    }else{

     if(searchPermission ==="Home" || searchPermission==="Logout"){
      isPermission = true;
     }else{
      isPermission = permissions.find(permission => permission.permission_name === searchPermission);
      
     }
    }

    isAuthenticated = decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).loggedin === 'loginValidated';
  }
  return isAuthenticated ? isPermission ?<Component/>:<NotAuthorised/>:<Navigate to="/login" />;
};

const AdminManagementRoute = ({ element: Component }) => {
  let isAdmin=false;
  if(localStorage.getItem('userSession')){
    isAdmin= decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).userlevel === 'ADMIN';
  }
  
  return isAdmin ? <Component /> : <Navigate to="/login" />;
};

const SuperAdminManagementRoute = ({ element: Component }) => {
  let isAdmin=false;
  if(localStorage.getItem('userSession')){
    isAdmin= decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).userlevel === 'SUPERADMIN';
  }
  
  return isAdmin ? <Component /> : <Navigate to="/login" />;
};



function App() {
  return (
    <Router>
      <Routes>

        <Route path="/login" element={<Login/>} />
       
        <Route path="/" element={<Template />}>
          <Route index element={<PrivateRoute element={Home} />} />
          <Route path="lockDevice" element={<PrivateRoute element={LockDevice} />} />
          <Route path="blockApp" element={<PrivateRoute element={BlockApp} />} />
          <Route path="unblockapp" element={<PrivateRoute element={UnblockApp} />} />
          <Route path="unlockDevice" element={<PrivateRoute element={UnlockDevice} />} />
          {/* <Route path="disableApp" element={<PrivateRoute element={DisableApp} />} /> */}
          <Route path="restoreApp" element={<PrivateRoute element={RestoreApp} />} />
          <Route path="setWallpaper" element={<PrivateRoute element={SetWallpaper} />} />
          <Route path="removeWallpaper" element={<PrivateRoute element={UnsetWallpaper} />} />
          <Route path="activateAlarm" element={<PrivateRoute element={ActivateAlarm} />} />
          <Route path="deactivateAlarm" element={<PrivateRoute element={UnsetAlarm} />} />
          <Route path="releaseDevice" element={<PrivateRoute element={Release} />} />
          <Route path="deviceDetails" element={<PrivateRoute element={DeviceDetail} />} />
          <Route path="enableNotification" element={<PrivateRoute element={EnableNotification} />} />
          <Route path="enableCamera" element={<PrivateRoute element={EnableCamera} />} />
          <Route path="disableCamera" element={<PrivateRoute element={DisableCamera} />} />
          <Route path="enableCredit" element={<PrivateRoute element={EnableCredit} />} />
          <Route path="revokeCredit" element={<PrivateRoute element={RevokeCredit} />} />
          <Route path="userManagement" element={<AdminManagementRoute element={UserManagement} />} />
          {/* <Route path="report" element={<PrivateRoute element={Report} />} /> */}
          <Route path="reports" element={<PrivateRoute element={Report} />} /> 
           {/* <Route path="reprocess" element={<PrivateRoute element={ReProcess} />} />            */}
          <Route path="gradeDisableApp" element={<PrivateRoute element={GradeDisableApp} />} />
          <Route path="batch" element={<PrivateRoute element={Batchprocess} />} />
          <Route path="appversion" element={<PrivateRoute element={AppVersion} />} />
          <Route path="lastCommand" element={<PrivateRoute element={LastCommand} />} />
          <Route path="formattedDevice" element={<PrivateRoute element={FormattedDevice} />} />
          <Route path='auditReport' element={<PrivateRoute element={AuditReportByImei} />} />
          <Route path="keyManagement" element={<KeyManagement />} />
          <Route path="logout" element={<PrivateRoute element={Logout} />} />
          </Route>

          <Route path="/superadmin/login" element={<Login clientof='SUPERADMIN'/>} />
          <Route path="/" element={<Template />}>
          <Route index element={<SuperAdminManagementRoute element={Home} />} />
          
        
          <Route path="superadmin/lockDevice" element={<SuperAdminManagementRoute element={LockDevice} />} />
          <Route path="superadmin/blockApp" element={<SuperAdminManagementRoute element={BlockApp} />} />
          <Route path="superadmin/unblockapp" element={<SuperAdminManagementRoute element={UnblockApp} />} />
          <Route path="superadmin/unlockDevice" element={<SuperAdminManagementRoute element={UnlockDevice} />} />
          {/* <Route path="superadmin/disableApp" element={<SuperAdminManagementRoute element={DisableApp} />} /> */}
          <Route path="superadmin/restoreApp" element={<SuperAdminManagementRoute element={RestoreApp} />} />
          <Route path="superadmin/setWallpaper" element={<SuperAdminManagementRoute element={SetWallpaper} />} />
          <Route path="superadmin/removeWallpaper" element={<SuperAdminManagementRoute element={UnsetWallpaper} />} />
          <Route path="superadmin/activateAlarm" element={<SuperAdminManagementRoute element={ActivateAlarm} />} />
          <Route path="superadmin/deactivateAlarm" element={<SuperAdminManagementRoute element={UnsetAlarm} />} />
          <Route path="superadmin/releaseDevice" element={<SuperAdminManagementRoute element={Release} />} />
          <Route path="superadmin/deviceDetails" element={<SuperAdminManagementRoute element={DeviceDetail} />} />
          <Route path="superadmin/enableNotification" element={<SuperAdminManagementRoute element={EnableNotification} />} />
          <Route path="superadmin/enableCamera" element={<SuperAdminManagementRoute element={EnableCamera} />} />
          <Route path="superadmin/disableCamera" element={<SuperAdminManagementRoute element={DisableCamera} />} />
          <Route path="superadmin/enableCredit" element={<SuperAdminManagementRoute element={EnableCredit} />} />
          <Route path="superadmin/revokeCredit" element={<SuperAdminManagementRoute element={RevokeCredit} />} />
          <Route path="superadmin/userManagement" element={<SuperAdminManagementRoute element={UserManagement} />} />
          {/* <Route path="superadmin/report" element={<PrivateRoute element={Report} />} /> */}
          <Route path="superadmin/reports" element={<SuperAdminManagementRoute element={Report} />} />
          {/* <Route path="superadmin/reprocess" element={<SuperAdminManagementRoute element={ReProcess} />} /> */}
          <Route path="superadmin/deviceAction" element={<SuperAdminManagementRoute element={DeviceAction} />} />
          <Route path="superadmin/gradeDisableApp" element={<SuperAdminManagementRoute element={GradeDisableApp} />} />
          <Route path="superadmin/batch" element={<SuperAdminManagementRoute element={Batchprocess} />} />
          <Route path="superadmin/appversion" element={<SuperAdminManagementRoute element={AppVersion} />} />
          <Route path="superadmin/lastCommand" element={<SuperAdminManagementRoute element={LastCommand} />} />
          <Route path="superadmin/formattedDevice" element={<SuperAdminManagementRoute element={FormattedDevice} />} />

          <Route path="superadmin/auditReport" element={<SuperAdminManagementRoute element={AuditReportByImei} />} />
          <Route path="superadmin/keyManagement" element={<KeyManagement />} />

          <Route path="superadmin/logout" element={<SuperAdminManagementRoute element={Logout} />} />
          </Route>
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/resetPassword/:token" element={<ResetPassword />} />

      </Routes>
    </Router>
  );
}
export default App;
